<script>
import { post } from '@tencent/pmd-network';
import { jsAdapterMixins } from '@tencent/pmd-vue/lib/vue/mixin/js-adapter';
import { tlogReportMixins } from '@tencent/pmd-vue/lib/vue/mixin/tlog-report';
import { QQBackUtils } from '@tencent/pmd-tools/lib/qq-back-util';
import { UserInfo } from '@tencent/pmd-tools/lib/user-info';
import { getUrlPara } from '@tencent/pmd-tools/lib/url';
import CommTipsDialog from '@tencent/press-ui/press-dialog';
import { gotoLogin } from 'src/component/logic/deprecated/request/comm';
import { setExtPlatScene, initDouyuChannelRouter, redirectToWebContainer } from 'src/local-logic/tip-match/douyu-channel/douyu-channel';
import { cookie } from '@tencent/pmd-tools/lib/storage';
import ShareTips from 'src/local-logic/tip-match/share-tips';
import { getUserInfo, queryMemberInfo } from 'src/local-logic/tip-match/user-info/index.js';
import { updateManager } from '@tencent/pmd-vue/lib/uni-utils';
import { addPerformanceListener } from 'src/local-logic/utils/mp-performance-report.js';
import { setComponent } from 'src/local-component/module/tip-match/global-component/global';
import { storePromise } from '@tencent/pmd-tools/lib/store-promise';
import { loaderWxApi } from '@tencent/pmd-tools/lib/weixin';
import { showComponentDialog } from '@tencent/pmd-tools/lib/dialog-displayer';
import { isQQChannel, initQQChannelRouter } from 'src/local-logic/tip-match/qq-channel/qq-channel';
import { loader } from '@tencent/pmd-tools/lib/little-loader';
import { initEnv, isTestEnv } from '@tencent/pmd-tools/lib/env';
import { GoodsConfigInfo } from '@tencent/pmd-config/lib/goods';
import { setAppInfo } from '@tencent/pmd-app-info/lib';
import { pageAnimation } from '@tencent/press-plus/common/page-animation/index';

import { initCampChannelRouter } from 'src/local-logic/tip-match/camp-channel/camp-channel';
// #ifdef H5
import { hookVueRouter } from '@tencent/press-plus/common/page-animation/hook-vue-router';
// #endif


/**
 * 无需登录态的页面
 * @type {string[]}
 */
const noLoginPages = [
  '/third-plat-login',
  '/phone-login',
  '/web-container',
];

export default {
  components: {
  },
  mixins: [jsAdapterMixins, tlogReportMixins],
  data() {
    return {
      isPageShowing: false,
      firstLoginInfo: true,
      isFirstShowWxOfficialDialog: false,
      env: initEnv(),
    };
  },
  onLaunch() {
    this.initCreated();
    this.initMounted();
    // #ifdef H5
    loader('https://captcha.gtimg.com/TCaptcha.js', () => {});
    window.addEventListener('resize', () => {
      console.log('resize');
      redirectToWebContainer({ router: this.$router, tag: 'resize' });
    });
    hookVueRouter(this.$router, {
      log: process.env.NODE_ENV === 'development',
    });

    pageAnimation({ router: this.$router });
    redirectToWebContainer({ router: this.$router, tag: 'onLaunch' });
    initDouyuChannelRouter(this.$router);
    initQQChannelRouter(this.$router);
    initCampChannelRouter(this.$router);
    // #endif
    // #ifndef H5
    uni.loadFontFace({
      global: true,
      scopes: ['webview', 'native'],
      family: 'DINCond-Bold',
      source: 'url("https://image-1251917893.file.myqcloud.com/TIP_GameSystem_2020/toC/v2.0/font/DINCondensedBold.ttf")',
      success(res) {
        console.log(res.status);
      },
      fail(res) {
        console.log(res);
      },
      complete(res) {
        console.log(res.status);
      },
    });
    // #endif
    // #ifdef H5
    if (app.env?.isWeixin) {
      loaderWxApi();
    }
    if (this.env?.isQQ && this.env.isMiniProgram) {
      loader('https://qqq.gtimg.cn/miniprogram/webview_jssdk/qqjssdk-1.0.0.js', () => {});
    }
    // #endif
    this.initGoodsDetailCGIUrl();
    // 来源参数
    const { utm_source: utmSource } = this.getRouteQueryObj() || {};
    if (utmSource === 'SMS') {
      this.SMSClickRecord();
    }
  },
  onShow() {
    console.log('app.onShow');
    this.isPageShowing = true;
    if (app?.IMHandler && !app?.IMHandler?.isOnline && UserInfo.tipUid()) {
      this.initIM(UserInfo.tipUid());
    }
    // 鸿蒙设备全局提示
    this.checkHarmonyOS();
  },
  onHide() {
    this.isPageShowing = false;
    console.log('app.onHide');
  },
  methods: {
    checkHarmonyOS() {
      setTimeout(() => {
        uni.getSystemInfo({
          success(res) {
            const version = Number(res.osVersion && res.osVersion.replace(/\./g, ''));
            if ((res.ua && res.ua.includes('ArkWeb')) || (res.osName && res.osName.includes('harmonyos') && version >= 500)) {
              localStorage.setItem('isOpenHarmony', 1);
              setTimeout(() => {
                CommTipsDialog.show({
                  title: '',
                  content: '本产品在OpenHarmony-5.0及以上系统会遇到「参赛无法拉起游戏」、「无法前往游戏观战」等问题，建议您暂时使用其他设备体验完整功能。',
                  confirmText: '我知道了',
                  cancelText: '',
                });
              }, 2500);
            } else {
              localStorage.setItem('isOpenHarmony', 0);
            }
          },
          fail(err) {
            console.error('获取设备信息失败', err);
          },
        });
      }, 500);
    },
    initCreated() {
      this.firstLoginInfo = true;
      this.initCrossPlatform();
      this.$ebus.on('show-chat-group', this.showGroup);
      this.$ebus.on('initLoginInfo', this.initLoginInfo);
      this.$ebus.on('event-showShareTipsDialog', this.showShareTipsDialog);
      this.$ebus.on('disable-auto-login', this.handleLogin);
      this.$ebus.on('show-toast', this.showToast);
      this.$ebus.on('event-on-mini-program-login', this.onMiniProgramLogin);
      this.$ebus.on('response-error-event', this.handleResponseError);
      this.$ebus.on('clickAuth', this.clickAuth);
      this.$ebus.on('dimissAuthDialog', this.closeMatchAuthLogin);
      this.checkSubscribe();
      // #ifndef H5
      updateManager();
      // #endif
      if (this.isMpWeixin) {
        addPerformanceListener();
      }
    },
    initMounted() {
      // this.initQQBackLogic();
      this.initMemberInfo();
      this.setTimeoutWork();
      this.initAdult();

      // #ifdef H5
      this.$router.afterEach(() => {
      // 首页是黑名单的情况下，二级页面要刷新
        this.initAdult();
      });
      // #endif

      setExtPlatScene();
      // #ifndef H5
      uni.onUserCaptureScreen(() => {
        setComponent('ScreenshotPrompt', {
          showPrompt: true,
        });
        setTimeout(() => {
          setComponent('ScreenshotPrompt', {
            showPrompt: false,
          });
        }, 5000);
      });
    // #endif
    },
    initCrossPlatform() {
      // #ifdef MP-WEIXIN || MP-QQ
      if (this.isMpWeixin || this.isMPQQ) {
        if (isTestEnv()) {
          window.location.host = 'h5-test.nes.smoba.qq.com';
          window.location.origin = 'https://h5-test.nes.smoba.qq.com';
          window.location.pathname = '/pvpesport.next.user.develop/';
        } else {
          window.location.host = 'h5.nes.smoba.qq.com';
          window.location.origin = 'https://h5.nes.smoba.qq.com';
          window.location.pathname = '/pvpesport.next.user/';
        }
        app.env.isWeixin = true;
        app.env.isMiniProgram = true;
        this.setStorageMenuInfo();
      }
      // #endif
    },
    checkSubscribe() {
      const env = app.env || this.computed_env;
      if (env
        && ((env.isWeixin && !env.isWorkWeixin) || env.isQQ)) {
        this.initSubscribe();
        document.addEventListener('visibilitychange', this.visibilityChangeFunc);
      }
      if (!this.isFirstShowWxOfficialDialog) {
        this.$ebus.on('show-weixin-official-dialog', this.clickNotify);
        this.isFirstShowWxOfficialDialog = true;
      }
    },
    initSubscribe() {
      getUserInfo()
        .then(() => {
        })
        .catch(() => {});
    },
    // 初始化手Q返回操作
    initQQBackLogic() {
      if (app.env.isQQ) {
        QQBackUtils.setQQFirstPageHash(window.location.hash, '#/home');
        QQBackUtils.setQQBackClick();
      }
    },
    setTimeoutWork() {
      setTimeout(() => {
        // this.projectReportStat();
        // eslint-disable-next-line no-undef
        if (typeof mqq !== 'undefined' && mqq.ui && mqq.ui.setWebViewBehavior) {
          // eslint-disable-next-line no-undef
          mqq.ui.setWebViewBehavior({
            actionButton: 1,
          });
        }
      }, 1000);
    },
    projectReportStat() {
      let sresv1 = 'other';
      if (app.env.isInGame) {
        sresv1 = 'wz_app';
      } else if (app.env.isPvpApp) {
        sresv1 = 'in_game';
      } else if (app.env.isWeixin || app.env.isQQ) {
        sresv1 = 'weixin_qq';
      }
      const params = {
        plat: app.env.isIos ? 2 : 1,
        merc_id: 'esport-pvp-user',
        module_id: 10006,
        oper_id: 100,
        gid: 331,
        sresv1,
        iresv2: 1,
      };
      post({
        showMsgToast: false,
        reqData: params,
        oldCGI: true,
        url: '/pvp/comm/report/stat_daily_number',
      }).then(() => {})
        .catch(() => {});
    },
    // 短信来源上报策略
    SMSClickRecord() {
      post({
        showMsgToast: false,
        reqData: {},
        url: '/pvpesport.sgamenes.commcgi.commcgi/SMSClickRecord',
      }).then(() => {})
        .catch(() => {});
    },
    showGroup() {
      this.reportPageExposure('match_group', 'all');
      this.reportPageExposure('match_global', 'all', {
        eventId: 'esports_chatroom_QR_show',
        elementId: app.env.isQQ ? 2 : 1,
      });
      // #ifdef H5

      showComponentDialog(
        this, () => import('src/local-component/ui/tip-match/tip-match-popup-join-group/index.vue'),
        {
          isQQ: app.env.isQQ,
          onClickOther: () => {
            this.reportClick('match_global', 'esports_chatroom_QR_typoe_change_click', 'all', { elementId: app.env.isQQ ? 2 : 1 });
            showComponentDialog(
              this, () => import('src/local-component/ui/tip-match/tip-match-popup-join-group/index.vue'),
              {
                isQQ: !app.env.isQQ,
                showBackArrow: true,
                onBack: () => {
                  this.showGroup();
                },
              },
            );
          },
        },
      );
      // #endif
    },
    showQQChannelBack() {
      if (app.$router) {
        if (app.$router.currentRoute.path.indexOf('/home') === -1) {
          return false;
        }
        return isQQChannel();
      }
      return false;
    },
    showHomeNavigator() {
      if (app.$router) {
        if (app.$router.currentRoute.path.indexOf('/home') === -1) {
          return true;
        }
        return isQQChannel();
      }
      return false;
    },
    initLoginInfo() {
      // 内部有限制只请求一次逻辑
      this.initAdult();
      if (this.firstLoginInfo) {
        this.$store.dispatch('commercial/initCommercialWhiteList');
        this.initAdult();
        this.firstLoginInfo = false;
      }
    },
    initAdult() {
      if (!UserInfo.tipUid() || UserInfo.tipUid().length <= 0) {
        return;
      }
      const initAdult = window.sessionStorage.getItem(`init-adult-${UserInfo.tipUid()}`);
      if (!this.adultBlackList()  && initAdult != '1') {
        window.sessionStorage.setItem(`init-adult-${UserInfo.tipUid()}`, '1');
        post({
          url: '/pvpesport.sgamenes.commcgi.commcgi/TrigGetUserRealInfo',
          showMsgToast: false,
          reqData: {
            gid: 331,
          },
        })
          .then(() => {
          })
          .catch(() => {
          })
          .finally(() => {
          });
      }
    },
    adultBlackList() {
      const blackList = [];
      for (let i = 0; i < blackList.length; i++) {
        if (window.location.href.indexOf(blackList[i]) > 0) {
          return true;
        }
      }
      return false;
    },
    visibilityChangeFunc() {
      // 监听浏览器当前页面是否被激活的事件
      let hiddenProperty = 'hidden';
      if ('webkitHidden' in document) {
        hiddenProperty = 'webkitHidden';
      } else if ('mozHidden' in document) {
        hiddenProperty = 'mozHidden';
      }
      if (!document[hiddenProperty]) {
        console.info('visibilityChangeFunc initSubscribe');
        this.initSubscribe();
      }
    },
    clickNotify(dialogProps = {}) {
      if (app.env.isGHelper) {
        CommTipsDialog.show({
          title: '赛事通知',
          content: '将通过小秘书发送比赛相关通知，请关注消息提醒',
          confirmText: '我知道了',
          cancelText: '',

        }).then(() => {

        })
          .catch(() => {

          });
      } else if (app.env.isWeixin || app.env.isQQ) {
        if (this.isSubscribeOfficialAccount()) {
          this.reportPageExposure('match_homepage', 'all', {
            eventId: 'esports_homepage_menu_notify_followed_show',
          });
          const acountName = '王者赛宝';
          CommTipsDialog.show({
            title: '赛事通知',
            content: `您已关注《${acountName}》公众号，请关注公众号赛事通知`,
            confirmText: '我知道了',
            cancelText: '',

          }).then(() => {

          })
            .catch(() => {

            });
        } else {
          const defaultDialogProps = {};
          defaultDialogProps.title = '便捷参赛与赛事通知';
          defaultDialogProps.subcontent = '可从公众号参加赛事并及时接受比赛动态';
          this.reportPageExposure('mp_guiid', 'all', { eventId: 'page_exposure' });
          this.reportPageExposure('match_homepage', 'all', {
            eventId: 'esports_homepage_menu_notify_QR_show',
          });
          let content;
          if (this.isMPQQ) {
            content = '点击查看大图，并长按保存图片';
          } else {
            content = dialogProps.content || '长按扫码关注公众号';
          }
          setComponent('UiOfficialAccountDialog', {
            title: dialogProps?.title || defaultDialogProps.title,
            content,
            subcontent: dialogProps?.subcontent || defaultDialogProps.subcontent,
            src: this.env.isQQ || this.isMPQQ ? 'https://image-1251917893.file.myqcloud.com/esport-web/qq_public_qrcode.png' : 'https://image-1251917893.file.myqcloud.com/Esports/new/user/icon-saibaogzh.png',
            canTouchRemove: true,
            confirmText: dialogProps.confirmText ||  '我知道了',
            cancelText: '',
            lightbtn: dialogProps.lightbtn || true,
            onConfirm: () => {
              this.reportClick('mp_guiid', 'esports_click_mp_guiid_sure_click');
            },
          })?.show();
        }
      }
    },
    isSubscribeOfficialAccount() {
      return window.sessionStorage.getItem('user-is-subscribe-offical-account') === '1';
    },
    showShareTipsDialog(txt) {
      if (!app.env.isMiniProgram) {
        const shareText = txt ? txt : '点击“...”分享链接';
        ShareTips({
          shareText,
        });
      }
    },
    initMemberInfo() {
      storePromise({
        key: 'QueryMemberInfo',
        promise: () => queryMemberInfo(),
      }).then((memberInfo) => {
        if (memberInfo?.uid) {
          const { uid } = memberInfo;
          this.initIM(uid);
          this.$ebus.emit('EVENT_BUS_LOGIN_SUC', uid);
          this.$store.dispatch('msgCenter/getTimMsg', uid);
          this.$store.dispatch('msgCenter/getTimUnReadCount', uid);
          window.sessionStorage.setItem('tip_uid', cookie.get('tip_uid'));
          this.$store.commit('user/setNick', memberInfo?.nick || '');
          this.$store.commit('user/setHead', memberInfo?.head || '');
          this.$store.commit('user/setUid', memberInfo?.uid || '');
          this.$store.commit('user/setGameInfo', memberInfo?.game_info || {});
        }
      })
        .catch((err) => {
          console.log('请求登录信息失败', err);
        });
    },
    handleLogin(response) {
      this.loginResponse = response;
      const { env } = this;
      /**
       * 是否是绑定登录态
       * @type {boolean}
       */
      const isBindCodeLogin = getUrlPara('extplat_type') === 'bindcode';
      if (env.isMiniProgram) {
        // 如果是小程序打开H5，不跳转登录。统一采用mpcode登录方式
        return;
      }
      if (isBindCodeLogin) {
        // 微信小程序内的H5，直接登录
        this.clickAuth();
      } else if (env.isWeixin) {
        // 微信拦截，出授权弹窗
        this.tipMatchAuthLogin();
      } else if (env.isQQ) {
        // QQ直接登录
        this.clickAuth();
      } else if (this.env.isTencentVideo) {
        CommTipsDialog.show({
          title: '温馨提示',
          content: '请先完成腾讯视频的账号登录',
          confirmText: '我知道了',
          cancelText: '',
        }).then(() => {

        })
          .catch(() => {

          });
      } else {
        // 其它跳转统一登录页面
        this.jumpLogin(response);
      }
    },
    tipMatchAuthLogin() {
      setComponent('UiTipMatchAuthLogin', { dialogIsShow: true });
    },
    closeMatchAuthLogin() {
      setComponent('UiTipMatchAuthLogin', { dialogIsShow: false });
    },
    jumpLogin(response) {
      for (let i = 0; i < noLoginPages.length; i++) {
        if (window.location?.href?.indexOf(noLoginPages[i]) !== -1) {
          sessionStorage.setItem('third-plat-login', JSON.stringify(response));
          return;
        }
      }
      try {
        sessionStorage.setItem('third-plat-login-last-href', window.location.href);
        sessionStorage.setItem('third-plat-login', JSON.stringify(response));
      } catch (e) {
        console.log(e);
      }
      uni.navigateTo({ url: '/views/other/third-plat-login/index' });
    },
    clickAuth() {
      gotoLogin(this.loginResponse);
    },
    initIM(tipUid) {
      console.log('initIM.tipUid', tipUid);
      if (tipUid) {
        app?.IMHandler?.login(tipUid || UserInfo.tipUid())
          .then(() => {
            const cb = () => {
              const nick = this.$store.state.user?.nick;
              const avatar = this.$store.state.user?.head;

              if (!nick || !avatar) return;

              app?.IMHandler?.updateMyProfile({
                nick: this.$store.state.user?.nick,
                avatar: this.$store.state.user?.head,
              }).then(() => {});
            };
            if (app?.IMHandler?.isReady) {
              cb();
            } else {
              app?.IMHandler?.setReadyListener(cb);
            }
          })
          .catch(() => {

          });
      }
    },
    onMiniProgramLogin() {
      // this.checkRegister();
      this.checkSubscribe();
      this.initAdult();
    },
    handleResponseError(error) {
      window.mAegis?.info(`:::Network response error: ${JSON.stringify(error)}`);
    },
    setStorageMenuInfo() {
      if (!this.isMpWeixin) return;
      const result = uni.getSystemInfoSync();
      const system = result.system?.toLowerCase?.();
      if (system?.indexOf('ios') !== -1) {
        app.env.isIOS = true;
        app.env.isIos = true;
      } else if (system?.indexOf('android') !== -1) {
        app.env.isAndroid = true;
      }
      // 获取手机系统的状态栏高度（不同手机的状态栏高度不同）
      const statusBarHeight = `${result.statusBarHeight}px`;

      // 获取右侧胶囊的信息 单位px
      const menuButtonInfo = uni.getMenuButtonBoundingClientRect();
      // bottom: 胶囊底部距离屏幕顶部的距离
      // height: 胶囊高度
      // left:   胶囊左侧距离屏幕左侧的距离
      // right:  胶囊右侧距离屏幕左侧的距离
      // top:    胶囊顶部距离屏幕顶部的距离
      // width:  胶囊宽度
      // 微信小程序导航栏固定高度44px
      const menuWidth = `${menuButtonInfo.width}px`;
      const menuHeight = `${menuButtonInfo.height}px`;
      const menuBorderRadius = `${menuButtonInfo.height / 2}px`;
      const menuRight = `${result.screenWidth - menuButtonInfo.right}px`;
      const menuTop = `${menuButtonInfo.top}px`;
      const contentTop = `${result.statusBarHeight + 44}px`;

      const menuInfo = {
        statusBarHeight, // 状态栏高度----用来给自定义导航条页面的顶部导航条设计padding-top使用：目的留出系统的状态栏区域
        menuWidth, // 右侧的胶囊宽度--用来给自定义导航条页面的左侧胶囊设置使用
        menuHeight, // 右侧的胶囊高度--用来给自定义导航条页面的左侧胶囊设置使用
        menuBorderRadius, // 一半的圆角--用来给自定义导航条页面的左侧胶囊设置使用
        menuRight, // 右侧的胶囊距离右侧屏幕距离--用来给自定义导航条页面的左侧胶囊设置使用
        menuTop, // 右侧的胶囊顶部距离屏幕顶部的距离--用来给自定义导航条页面的左侧胶囊设置使用
        contentTop, // 内容区距离页面最上方的高度--用来给自定义导航条页面的内容区定位距离使用
        headerHeight: result.statusBarHeight + 44, // ui/tip-match/tip-match-global-notice/index.vue需要
      };
      uni.setStorageSync('menuInfo', menuInfo);
    },
    initGoodsDetailCGIUrl() {
      const service = '/PromoPlatform.Game.exchange.exchange';
      GoodsConfigInfo.instance.exchangeUrl = `${service}/Exchange`;
      GoodsConfigInfo.instance.queryRoleListUrl = `${service}/QueryRoleList`;
      GoodsConfigInfo.instance.sendTelMsgCodeUrl = `${service}/SendTelMsgCode`;
      GoodsConfigInfo.instance.queryGoodsDetailInfoV1Url = `${service}/QueryGoodsDetailInfoV1`;
      GoodsConfigInfo.instance.queryUserWaterListUrl = `${service}/QueryUserWaterList`;
      GoodsConfigInfo.instance.setBindRelationUrl = `${service}/SetBindRelation`;
      GoodsConfigInfo.instance.getBindRelationUrl = `${service}/GetBindRelation`;
      GoodsConfigInfo.instance.getBindTokenUrl = `${service}/GetBindToken`;
      GoodsConfigInfo.instance.bindWeixinUrl = `${this.getUrlPath()}/views/award/my-award-weixin`;
      GoodsConfigInfo.instance.getRainbowConfigUrl = '/tipmp.user.commreport.commreport/FrontConfig';
      GoodsConfigInfo.instance.updateUserPhone = `${service}/UpdateUserPhone`;

      GoodsConfigInfo.instance.forceUseQueryRoleList = true;
      setAppInfo('GoodsConfigInfo.instance.getMiniProgramOpenLinkUrl', `${service}/GetMiniProgramOpenLink`);
    },
  },
};

</script>
<style lang="scss" src="src/pages/base/common.scss"></style>
<style lang="scss">
.hidden-van-tabs .press-tabs--can-hidden .van-tabs__wrap {
  display: none;
}
.hidden-van-tabs .press-tabs--can-hidden .van-schedule-tabs__wrap {
  display: none;
}
uni-page-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100% !important;
  background: #f5f6fa;
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>
